import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { setupGlobalErrorHandlers } from './utils/globalErrorHandler';
import { initWebVitals } from './utils/webVitals';

// グローバルエラーハンドラーを設定
setupGlobalErrorHandlers();

// Web Vitals監視を初期化
initWebVitals();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
